/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Component } from 'react';
import { Button, Col } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import { withSnackbar } from 'react-simple-snackbar';
import PropTypes from 'prop-types';

import breakfast from 'assets/images/dayplan/breakfast.jpeg';
import dinner from 'assets/images/dayplan/dinner.jpeg';
import eveningSnack from 'assets/images/dayplan/evening-snack.jpeg';
import supper from 'assets/images/dayplan/supper.jpeg';

import favouriteFull from 'assets/images/favourites/favourite-full.svg';
import withFirebase from 'view/FirebaseAnalytics/withFirebase';

const steps = [5, 15, 30, 45, 60];

class FavMeal extends Component {
    static propTypes = {
        preparationTime: PropTypes.shape({
            years: PropTypes.number,
            days: PropTypes.number,
            hours: PropTypes.number,
            minutes: PropTypes.number,
            seconds: PropTypes.number,
        }).isRequired,
        name: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
        mealId: PropTypes.number.isRequired,
        toggleModal: PropTypes.func.isRequired,
        preparationImageUrl: PropTypes.string,
        publicName: PropTypes.string.isRequired,
        removeMealFromFavorites: PropTypes.shape({
            removeMeal: PropTypes.func.isRequired,
            response: PropTypes.shape(),
            loading: PropTypes.bool,
            error: PropTypes.shape(),
        }).isRequired,
        addMealToFavorites: PropTypes.shape({
            addMeal: PropTypes.func.isRequired,
            response: PropTypes.shape(),
            loading: PropTypes.bool,
            error: PropTypes.shape(),
        }).isRequired,
        openSnackbar: PropTypes.func.isRequired,
        toggleInsertDate: PropTypes.func.isRequired,
        trackFirebaseEvent: PropTypes.func.isRequired,
        kcal: PropTypes.number.isRequired,
    };

    static defaultProps = {
        preparationImageUrl: undefined,
    };

    static calculatePreparationTime(minutes) {
        if (minutes === 0 || minutes == null) {
            return null;
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const step of steps) {
            if (minutes <= step) {
                return `< ${step}`;
            }
        }
        return `> ${steps[steps.length - 1]}`;
    }

    state = {
        hide: false,
    };

    handleMealClick() {
        this.props.toggleModal(this.props.mealId);
    }

    handleRemoveMeal = () => {
        this.setState({ hide: true });
        setTimeout(async () => {
            try {
                const mealId = this.props.mealId;
                await this.props.removeMealFromFavorites.removeMeal(mealId);
                if (
                    this.props.removeMealFromFavorites.response.me
                        .removeMealFromFavoritesByMealId.__typename ===
                    'BasicMutationSuccess'
                ) {
                    this.props.openSnackbar(
                        <p>
                            {this.props.t('fav-meals/removed')}
                            <Button
                                color="link"
                                onClick={() => this.handleAddMeal(mealId)}
                            >
                                {this.props.t('fav-meals/back')}
                            </Button>
                        </p>
                    );
                    this.props.trackFirebaseEvent('user_action', {
                        action: 'tap-delete_favourites',
                        location: 'V_favourites',
                        meal_id: this.props.mealId,
                        meal_category: this.props.name,
                    });
                }
            } catch (error) {
                throw new Error(
                    `Failed to remove meal from favorites: ${error}`
                );
            }
        }, 500);
    };

    handleAddMeal = async mealId => {
        try {
            await this.props.addMealToFavorites.addMeal(mealId);
        } catch (error) {
            throw new Error(`Failed to add meal to favorites: ${error}`);
        }
    };

    renderMealImage = () => {
        let mealImg;

        if (this.props.preparationImageUrl) {
            mealImg = this.props.preparationImageUrl;
        } else {
            switch (this.props.name) {
                case 'Breakfast':
                    mealImg = breakfast;
                    break;
                case 'Lunch':
                    mealImg = supper;
                    break;
                case 'Snack':
                    mealImg = eveningSnack;
                    break;
                case 'Dinner':
                    mealImg = dinner;
                    break;
                default:
                    mealImg = breakfast;
            }
        }

        return (
            <div
                className="embed-responsive embed-responsive-16by9"
                role="button"
                onClick={() => this.handleMealClick()}
            >
                <div
                    style={{
                        backgroundImage: `url(${mealImg})`,
                    }}
                    className="embed-responsive-item"
                />
            </div>
        );
    };

    render() {
        return (
            <>
                <Col
                    xs="6"
                    md="4"
                    className={
                        this.state.hide
                            ? 'meal animated fadeOut'
                            : 'meal animated fadeIn'
                    }
                >
                    <div className="white-box meal-box">
                        {this.renderMealImage()}
                        <button
                            className="add-remove-fav mt-2"
                            type="button"
                            onClick={() => this.handleRemoveMeal()}
                        >
                            <img src={favouriteFull} alt="" />
                        </button>
                        <div
                            role="button"
                            className="meal-title"
                            onClick={() => this.handleMealClick()}
                        >
                            <p className="semi-bold on-surface">
                                {this.props.publicName}
                            </p>
                        </div>

                        <p>{this.props.kcal} kcal</p>

                        <div className="text-center">
                            <Button
                                color="primary"
                                size="sm"
                                onClick={() =>
                                    this.props.toggleInsertDate(
                                        this.props.mealId
                                    )
                                }
                                className="w-100 px-0"
                            >
                                {this.props.t('meal/add-to-dayplan')}
                            </Button>
                        </div>
                    </div>
                </Col>
            </>
        );
    }
}

export default withFirebase(withSnackbar(withLocale(FavMeal)));
